import React from 'react'

const IconDefaultCheckbox = () => {
  return (
    <svg viewBox='0 0 24 24' fill='none'>
      <rect x='3' y='3' width='18' height='18' rx='2' stroke='currentColor' strokeWidth='2' />
    </svg>
  )
}

export default IconDefaultCheckbox
